import { ReportStaysEntity } from "../domain/reportStays.entity";

export interface ReportStaysDTO {
  result: ReportStaysResultDTO[];
  page: number;
  totalPages: number;
  totalResults: number;
  size: number;
  staysReportSummary: ReportStaysSummaryDTO;
}

export interface ReportStaysResultDTO {
  bookingId: string;
  capacity: number;
  comments: string;
  currentNight: string;
  customerName: string;
  date: string;
  dayOfTheWeek: string;
  extras: string;
  foreignId: number;
  hotelTicker: string;
  multipleBookingId: string;
  roomTicker: string;
  rooms: number;
  totalNights: number;
}

export interface ReportStaysSummaryDTO {
  avgOfCapacities: string;
  avgOfCurrentNight: string;
  avgOfRooms: string;
  avgOfTotalNights: string;
  sumOfCapacities: number;
  sumOfCurrentNight: number;
  sumOfRooms: number;
  sumOfTotalNights: number;
}

function numberRound(value: number): number {
  return Math.round(value * 100) / 100
}

function calculateAction(currentNight: string, totalNight: number): string {
  if (currentNight === "-") {
    return "checkOut";
  }
  if (totalNight === 1) {
    return "checkIn";
  }
  return currentNight === "1" ? "checkIn" : "stay";
}

export function dtoToEntity(dto: ReportStaysDTO, sumText: string, avgText: string): ReportStaysEntity[] {
  if (!dto?.result?.length) {
    return [];
  }
  const entity = dto.result.map(((it, index) => ({
    id: index,
    action: calculateAction(it.currentNight, it.totalNights),
    bookingId: it.bookingId,
    capacity: it.capacity,
    comments: it.comments,
    currentNight: it.currentNight,
    customerName: it.customerName,
    date: it.date,
    dayOfTheWeek: it.dayOfTheWeek,
    extras: it.extras,
    propertyTicker: it.hotelTicker,
    multipleBookingId: it.multipleBookingId,
    inventoryTicker: it.roomTicker,
    rooms: it.rooms,
    totalNights: it.totalNights,
  })));

  // Total sum
  entity.push({
    id: dto.result.length,
    action: "",
    bookingId: "",
    capacity: numberRound(dto.staysReportSummary.sumOfCapacities),
    comments: "",
    currentNight: "",
    customerName: "",
    date: sumText,
    dayOfTheWeek: "",
    extras: "",
    propertyTicker: "",
    multipleBookingId: "",
    inventoryTicker: "",
    rooms: numberRound(dto.staysReportSummary.sumOfRooms),
    totalNights: numberRound(dto.staysReportSummary.sumOfTotalNights),
  });

  // Total average
  entity.push({
    id: dto.result.length + 1,
    action: "",
    bookingId: "",
    capacity: numberRound(Number(dto.staysReportSummary.avgOfCapacities)),
    comments: "",
    currentNight: "",
    customerName: "",
    date: avgText,
    dayOfTheWeek: "",
    extras: "",
    propertyTicker: "",
    multipleBookingId: "",
    inventoryTicker: "",
    rooms: numberRound(Number(dto.staysReportSummary.avgOfRooms)),
    totalNights: numberRound(Number(dto.staysReportSummary.avgOfTotalNights)),
  });

  return entity;
}
